module.exports = __webpack_public_path__ + "static/media/ottawa-12.4bc2eaa8.jpg";